import { Box, Typography } from "@mui/material";

const InfoRow = ({ label, value, labelWeight ='normal', valueWeight='normal', labelColor='#636363', valueColor='#636363' }) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", my: 1, cursor: 'pointer' }}>
        <Typography variant="body2" sx={{ color: labelColor, fontWeight: labelWeight}} >{label}</Typography>
        <Typography variant="body2" sx={{ color: valueColor, fontWeight: valueWeight}}>{value}</Typography>
    </Box>
);
export default InfoRow;